import { PAGE_ONE } from "ui/pagination";
import { IPaginationParams } from "ui/pagination/types";

export const columns = [
  "Payroll Date",
  "Payroll Name",
  "Payroll Amount",
  "Employees",
  "Fee",
  "Tax Remittance",
  "Pension Remittance",
  "Status",
];

export const DEFAULT_PAYROLLS_TABLE_PAGE_LIMIT = 10;
export const DEFAULT_PAYROLLS_TABLE_PAGINATION_PARAMS: IPaginationParams = {
  page: PAGE_ONE,
  limit: DEFAULT_PAYROLLS_TABLE_PAGE_LIMIT,
};
